const styles = {
	container: {
		overflow: 'scroll', 
		marginBottom: '20px', 
		marginTop: '10px',
	},
}

export default styles
